import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const create = async function(data) {
    const {userId, displayName, password, group} = data;   
    const user = {
        userId,
        group,
        displayName,
        password
    };
    return apiService.post('user', user);
}

export default {
    create,
}